export const INVENTORY_ACTION_DELIVERED = 'delivered'
export const INVENTORY_ACTION_FOR_SALE_ONLINE = 'for-sale-online'
export const INVENTORY_ACTION_UNDER_NEGOTIATION = 'under-negotiation'
export const INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST =
  'under-negotiation-from-price-change-request'
export const INVENTORY_ACTION_REPAIR_REQUEST = 'repair-request'
export const INVENTORY_ACTION_REPAIR_CONFIRMATION = 'repair-confirmation'
export const INVENTORY_ACTION_REVERT_CHANGE_STATE = 'revert-change-state'
export const INVENTORY_ACTION_PRICE_CHANGE_REQUEST = 'price-change-request'
export const INVENTORY_ACTION_RETURN = 'return'
export const INVENTORY_ACTION_RETURN_TRANSPORTATION_REQUEST =
  'return-transportation-request'
export const INVENTORY_ACTION_RETURN_TRANSPORTATION_CONFIRMED =
  'return-transportation-confirmed'
export const INVENTORY_ACTION_RETURN_CAR_LOADED = 'return-car-loaded'
export const INVENTORY_ACTION_RETURN_CAR_ARRIVED = 'return-car-arrived'
export const INVENTORY_ACTION_PURCHASE_REQUEST = 'purchase-request'
export const INVENTORY_ACTION_PURCHASE_REQUEST_B2B = 'purchase-request-b2b'
export const INVENTORY_ACTION_INVOICED = 'invoiced'
export const INVENTORY_ACTION_CANCELED = 'canceled'
export const INVENTORY_ACTION_PAYMENT_CONFIRMATION = 'payment-confirmation'
export const INVENTORY_ACTION_SOLD = 'sold'
export const INVENTORY_ACTION_DOCUMENTS_RECEIVED = 'documents-received'
export const INVENTORY_ACTION_FINAL_CUSTOMER_INVOICE = 'final-customer-invoice'
export const INVENTORY_ACTION_CHECK_OK = 'check-ok'

export const INVENTORY_ACTION_DOWNLOAD_DOCUMENTS = 'download-documents'
export const INVENTORY_ACTION_PRICE_CHANGES = 'price-changes'
export const INVENTORY_ACTION_STATE_HISTORY_INFO = 'state-history-info'
export const INVENTORY_ACTION_DOWNLOAD_REPORT = 'download-report'

export const INVENTORY_ACTIONS = {
  [INVENTORY_ACTION_DELIVERED]: {
    action: INVENTORY_ACTION_DELIVERED,
    label: 'partnerInventory.menu.delivered',
    dataId: 'action-menu-delivered',
  },
  [INVENTORY_ACTION_FOR_SALE_ONLINE]: {
    action: INVENTORY_ACTION_FOR_SALE_ONLINE,
    label: 'partnerInventory.menu.forSaleOnline',
    dataId: 'action-menu-for-sale-online',
  },
  [INVENTORY_ACTION_UNDER_NEGOTIATION]: {
    action: INVENTORY_ACTION_UNDER_NEGOTIATION,
    label: 'partnerInventory.menu.underNegotiation',
    dataId: 'action-menu-under-negotiation',
  },
  [INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST]: {
    action: INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST,
    label: 'partnerInventory.menu.underNegotiationFromPriceChangeRequest',
    dataId: 'action-menu-under-negotiation-from-price-change-request',
  },
  [INVENTORY_ACTION_REPAIR_REQUEST]: {
    action: INVENTORY_ACTION_REPAIR_REQUEST,
    label: 'partnerInventory.menu.repairRequest',
    dataId: 'action-menu-repair-request',
  },
  [INVENTORY_ACTION_REPAIR_CONFIRMATION]: {
    action: INVENTORY_ACTION_REPAIR_CONFIRMATION,
    label: 'partnerInventory.menu.repairConfirmation',
    dataId: 'action-menu-repair-confirmation',
  },
  [INVENTORY_ACTION_REVERT_CHANGE_STATE]: {
    action: INVENTORY_ACTION_REVERT_CHANGE_STATE,
    label: 'partnerInventory.menu.revertChangeState',
    dataId: 'action-menu-revert-change-state',
  },
  [INVENTORY_ACTION_PRICE_CHANGE_REQUEST]: {
    action: INVENTORY_ACTION_PRICE_CHANGE_REQUEST,
    label: 'partnerInventory.menu.priceChangeRequest',
    dataId: 'action-menu-price-change-request',
  },
  [INVENTORY_ACTION_PURCHASE_REQUEST]: {
    action: INVENTORY_ACTION_PURCHASE_REQUEST,
    label: 'partnerInventory.menu.purchaseRequest',
    dataId: 'action-menu-purchase-request',
  },
  [INVENTORY_ACTION_PURCHASE_REQUEST_B2B]: {
    action: INVENTORY_ACTION_PURCHASE_REQUEST_B2B, // Use the standard purchase request
    label: 'partnerInventory.menu.purchaseRequestB2b',
    dataId: 'action-menu-purchase-request-b2b',
  },
  [INVENTORY_ACTION_RETURN]: {
    action: INVENTORY_ACTION_RETURN,
    label: 'partnerInventory.menu.return',
    dataId: 'action-menu-return',
  },
  [INVENTORY_ACTION_RETURN_TRANSPORTATION_REQUEST]: {
    action: INVENTORY_ACTION_RETURN_TRANSPORTATION_REQUEST,
    label: 'partnerInventory.menu.returnTransportationRequest',
    dataId: 'action-menu-return-transportation-request',
  },
  [INVENTORY_ACTION_RETURN_TRANSPORTATION_CONFIRMED]: {
    action: INVENTORY_ACTION_RETURN_TRANSPORTATION_CONFIRMED,
    label: 'partnerInventory.menu.returnTransportationConfirmed',
    dataId: 'action-menu-return-transportation-confirmed',
  },
  [INVENTORY_ACTION_RETURN_CAR_LOADED]: {
    action: INVENTORY_ACTION_RETURN_CAR_LOADED,
    label: 'partnerInventory.menu.returnCarLoaded',
    dataId: 'action-menu-return-car-loaded',
  },
  [INVENTORY_ACTION_RETURN_CAR_ARRIVED]: {
    action: INVENTORY_ACTION_RETURN_CAR_ARRIVED,
    label: 'partnerInventory.menu.returnCarArrived',
    dataId: 'action-menu-return-car-arrived',
  },
  [INVENTORY_ACTION_INVOICED]: {
    action: INVENTORY_ACTION_INVOICED,
    label: 'partnerInventory.menu.invoiced',
    dataId: 'action-menu-invoiced',
  },
  [INVENTORY_ACTION_CANCELED]: {
    action: INVENTORY_ACTION_CANCELED,
    label: 'partnerInventory.menu.canceled',
    dataId: 'action-menu-canceled',
  },
  [INVENTORY_ACTION_PAYMENT_CONFIRMATION]: {
    action: INVENTORY_ACTION_PAYMENT_CONFIRMATION,
    label: 'partnerInventory.menu.paymentConfirmation',
    dataId: 'action-menu-payment-confirmation',
  },
  [INVENTORY_ACTION_SOLD]: {
    action: INVENTORY_ACTION_SOLD,
    label: 'partnerInventory.menu.sold',
    dataId: 'action-menu-sold',
  },
  [INVENTORY_ACTION_DOCUMENTS_RECEIVED]: {
    action: INVENTORY_ACTION_DOCUMENTS_RECEIVED,
    label: 'partnerInventory.menu.documentsReceived',
    dataId: 'action-menu-documents-received',
  },
  [INVENTORY_ACTION_FINAL_CUSTOMER_INVOICE]: {
    action: INVENTORY_ACTION_FINAL_CUSTOMER_INVOICE,
    label: 'partnerInventory.menu.finalCustomerInvoice',
    dataId: 'action-menu-final-customer-invoice',
  },
  [INVENTORY_ACTION_CHECK_OK]: {
    action: INVENTORY_ACTION_CHECK_OK,
    label: 'partnerInventory.menu.checkOk',
    dataId: 'action-menu-check-ok',
  },
  [INVENTORY_ACTION_DOWNLOAD_DOCUMENTS]: {
    action: INVENTORY_ACTION_DOWNLOAD_DOCUMENTS,
    label: 'partnerInventory.menu.downloadDocuments',
    dataId: 'action-menu-download-documents',
  },
  [INVENTORY_ACTION_PRICE_CHANGES]: {
    action: INVENTORY_ACTION_PRICE_CHANGES,
    label: 'partnerInventory.menu.priceChanges',
    dataId: 'action-menu-price-changes',
  },
  [INVENTORY_ACTION_STATE_HISTORY_INFO]: {
    action: INVENTORY_ACTION_STATE_HISTORY_INFO,
    label: 'partnerInventory.menu.stateHistoryInfo',
    dataId: 'action-menu-state-history-info',
  },
  [INVENTORY_ACTION_DOWNLOAD_REPORT]: {
    action: INVENTORY_ACTION_DOWNLOAD_REPORT,
    label: 'partnerInventory.menu.downloadReport',
    dataId: 'action-menu-download-report',
  },
}
